<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>上限配置</span>
          <sync-data />
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="体力恢复" name="recovery">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.recovery" :key="index">
                <el-form-item label="等级">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
                </el-form-item>
                <el-form-item label="上限">
                  <el-input v-model.number="item.upLimit" style="width: 100px;" placeholder="上限" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:upLimit:del']" type="danger" @click="del('recovery', index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="add('recovery')">+</el-button>
                <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="onSubmit('recovery')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="盾牌上限" name="shield">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.shield" :key="index">
                <el-form-item label="等级">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
                </el-form-item>
                <el-form-item label="上限">
                  <el-input v-model.number="item.upLimit" style="width: 100px;" placeholder="上限" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:upLimit:del']" type="danger" @click="del('shield', index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="add('shield')">+</el-button>
                <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="onSubmit('shield')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="体力上限" name="spins">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.spins" :key="index">
                <el-form-item label="等级">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
                </el-form-item>
                <el-form-item label="上限">
                  <el-input v-model.number="item.upLimit" style="width: 100px;" placeholder="上限" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:upLimit:del']" type="danger" @click="del('spins', index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="add('spins')">+</el-button>
                <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="onSubmit('spins')">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getLimitCfgList, updateLimitCfg } from '@/api/config/up-limit-cfg'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'UpLimit',
  components: { SyncData },
  data() {
    return {
      activeName: 'recovery',
      formData: {
        recovery: [{
          levelId: 0,
          upLimit: 0
        }],
        shield: [{
          levelId: 0,
          upLimit: 0
        }],
        spins: [{
          levelId: 0,
          upLimit: 0
        }]
      }
    }
  },
  created() {
    this.getTables(this.activeName)
  },
  methods: {
    add(name) {
      this.formData[name].push({
        levelId: 0,
        upLimit: 0
      })
    },
    onSubmit(name) {
      const data = JSON.stringify(this.formData[name])
      console.log(data)
      updateLimitCfg({ name: name, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(name) {
      getLimitCfgList({ name: name }).then(res => {
        if (res.code === 200) {
          this.formData[name] = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(name, index) {
      this.formData[name] = this.formData[name].filter((item, key) => {
        return key !== index
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
      this.getTables(tab.name)
    }
  }
}
</script>

<style scoped>
</style>
